module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": 'Receive Study Notes'
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-mt-0"
  }, [(_vm.receivedShares.length > 0) ? _vm._c('PanelBody', {
    staticClass: "xs-pt-20 xs-pb-20"
  }, [_vm._l((_vm.receivedShares), function(share) {
    return _vm._c('ReceiveChapterRow', {
      attrs: {
        "share": share
      }
    })
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "xs-pt-20"
  }, [_vm._c('strong', [_vm._v("Import selected study notes to:")]), _vm._c('br'), _vm._v(" "), _vm._c('div', {
    staticClass: "row xs-mt-10"
  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('div', {
    staticClass: "col-md-6"
  }, [_vm._c('label', {
    attrs: {
      "for": "lectureNoteSubject"
    }
  }, [_vm._v("Place in existing subject")]), _vm._v(" "), _vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSubjectId),
      expression: "selectedSubjectId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "lectureNoteSubject"
    },
    on: {
      "change": [function($event) {
        _vm.selectedSubjectId = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.newSubjectTitle = ''
      }]
    }
  }, [_vm._c('option'), _vm._v(" "), _vm._l((_vm.subjects), function(subject) {
    return _vm._c('option', {
      domProps: {
        "value": subject.id
      }
    }, [_vm._v(_vm._s(subject.title))])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "col-md-6"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('label', {
    attrs: {
      "for": "newLectureNoteSubject"
    }
  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('span', [_vm._v("Or ")]) : _vm._e(), _vm._v("Create a new subject")]), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSubjectTitle),
      expression: "newSubjectTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "newLectureNoteSubject",
      "placeholder": "Subject Name"
    },
    domProps: {
      "value": _vm._s(_vm.newSubjectTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSubjectTitle = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-right buttons"
  }, [_vm._c('button', {
    staticClass: "btn btn-danger btn-xl",
    attrs: {
      "disabled": _vm.selectedShareImportIds.length <= 0 || _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.declineSelected()
      }
    }
  }, [_vm._v("Decline selected")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.selectedShareImportIds.length <= 0 || !_vm.validSubject || _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.importSelected()
      }
    }
  }, [_vm._v("Import selected")]), _vm._v("  \n              ")])])], 2) : _vm._c('PanelBody', {
    staticClass: "xs-pt-20 xs-pb-20"
  }, [_vm._c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("No study notes to import")])])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-186f0ac6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-sharer/ReceiveChapter.vue
// module id = 629
// module chunks = 1